<template>
  <section id="header" class="header_area">
    <div id="header_navbar" class="header_navbar sticky" style="border-bottom: 5px solid #f06a25;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <nav class="navbar navbar-expand-lg">
              <a class="navbar-brand" href="#" @click="showBeranda = true">
                <div>
                  <img
                    id="logo"
                    src="assets/images/logokaiv4.png"
                    alt="Logo"
                    style="max-width: 200px; height: auto;"
                  />
                  <!-- <span
                    style="
                      border-left: 2px solid black;
                      height: 40px;
                      position: absolute;
                      margin: 10px 10px 10px 10px;
                    "
                  ></span> -->
                  <!-- &nbsp;
                  &nbsp;
                  <img
                    id="logo"
                    src="assets/images/logo_tjsl.png"
                    alt="Logo"
                    style="max-width: 70px"
                  /> -->
                </div>
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="toggler-icon"></span>
                <span class="toggler-icon"></span>
                <span class="toggler-icon"></span>
              </button>
              <div
                class="collapse navbar-collapse sub-menu-bar"
                id="navbarSupportedContent"
              >
                <ul id="nav" class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <a class="page-scroll" :class="{ active: this.beranda }" @click="showBeranda = true;" href="#">BERANDA</a>
                  </li>
                  <li class="nav-item">
                    <a class="page-scroll" :class="{ active: this.artikel }" @click="showArtikel = true;" href="#oh4nvYyqLLXPHlteaBepbTEO8xTQ2tRCN0oc3ztR6R0=">ARTIKEL</a>
                  </li>
                  <li class="nav-item">
                    <a class="page-scroll" :class="{ active: this.foto }" @click="sendEmit('eoJZ+vmZ2drETZbIHklwyBa7O/TY6RuVJqvkmwVP0ik=', 'foto')" href="#eoJZ+vmZ2drETZbIHklwyBa7O/TY6RuVJqvkmwVP0ik=">GALERI FOTO</a>
                  </li>
                  <li class="nav-item">
                    <a class="page-scroll" :class="{ active: this.video }" @click="sendEmit('QBUXVZtdDHnBbwibb4V3aHGjudScUMWXc/aBCur+aYM=', 'video')" href="#QBUXVZtdDHnBbwibb4V3aHGjudScUMWXc/aBCur+aYM=">GALERI VIDEO</a>
                  </li>
                  <li class="nav-item">
                    <a :class="{ active: this.profil }" @click="sendEmit('f3vCjFysfaYgBxnsDcfOh+0/+Jgv9HhEdkVzwJHNrvo=', 'profil')" href="#f3vCjFysfaYgBxnsDcfOh+0/+Jgv9HhEdkVzwJHNrvo=">PROFIL TJSL KAI</a>
                  </li>
                  <li class="nav-item">
                    <a :class="{ active: this.aturan }" @click="sendEmit('W0OOXGIVabMoAhH8rNdMqkq5FjcunPK+CaXrRUBBVZY=', 'aturan')" href="#W0OOXGIVabMoAhH8rNdMqkq5FjcunPK+CaXrRUBBVZY=">ATURAN TJSL</a>
                  </li>
                  <li class="nav-item">
                    <a :class="{ active: this.faq }" @click="showFaq = true;" href="#y9mpGq6gyPvCumKeuzsP5RJyplziJtQmRS5529r4ApY=">FAQ</a>
                  </li>
                  <!-- <li style="position: relative; margin-left: 40px;">
                    <a style="position: relative; padding: 10px 0;"><i class="lni lni-search-alt"></i></a>
                  </li> -->
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <div
    class="header-nav-feature header-nav-features-search header-nav-features-search-reveal header-nav-features-search-reveal-big-search header-nav-features-search-reveal-big-search-full"
  >
    <div class="container">
      <div class="row h-100 d-flex">
        <div class="col h-100 d-flex">
          <form
            class="d-flex h-100 w-100"
            action="?_it8tnz=T1RBeE1EQXdNREF3&amp;_8dnts=Y0dGblpWOXpaV0Z5WTJnPQ==&amp;_8zph8="
            method="post"
          >
            <div class="big-search-header input-group">
              <input
                type="search"
                class="form-control text-1 text-dark"
                id="headerSearch"
                name="key_search"
                placeholder="Silahkan ketik kata kunci lalu enter..."
                required=""
              />
              <input type="hidden" id="_filter" name="_filter" value="1" />
              <a href="#" class="header-nav-features-search-hide-icon"
                ><i
                  class="fas fa-times header-nav-top-icon text-danger text-10"
                ></i
              ></a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  props: {
    visibleBeranda: Boolean,
    visibleArtikel: Boolean,
    visibleFoto: Boolean,
    visibleVideo: Boolean,
    visibleProfil: Boolean,
    visibleAturan: Boolean,
    visibleFaq: Boolean,
  },
  components: {},
  data() {
    return {
      beranda: false,
      artikel: false,
      foto: false,
      video: false,
      profil: false,
      aturan: false,
      faq: false,
    };
  },
  computed: {
    showBeranda: {
      get() {
        return this.visibleBeranda;
      },
      set(visibleBeranda) {
        this.$emit("berandaClicked", visibleBeranda);
        this.beranda = true;
        this.artikel = false;
        this.foto = false;
        this.video = false;
        this.profil = false;
        this.aturan = false;
        this.faq = false;
      },
    },
    showArtikel: {
      get() {
        return this.visibleArtikel;
      },
      set(visibleArtikel) {
        this.$emit("artikelClicked", visibleArtikel);
        this.beranda = false;
        this.artikel = true;
        this.foto = false;
        this.video = false;
        this.profil = false;
        this.aturan = false;
        this.faq = false;
      },
    },
    showFoto: {
      get() {
        return this.visibleFoto;
      },
      set(visibleFoto) {
        this.$emit("fotoClicked", visibleFoto);
        this.beranda = false;
        this.artikel = false;
        this.foto = true;
        this.video = false;
        this.profil = false;
        this.aturan = false;
        this.faq = false;
        // console.log('beranda ' + this.beranda);
        // console.log('artikel ' + this.artikel);
        // console.log('foto ' + this.foto);
        // console.log('video ' + this.video);
        // console.log('profil ' + this.profil);
      },
    },
    showVideo: {
      get() {
        return this.visibleVideo;
      },
      set(visibleVideo) {
        this.$emit("videoClicked", visibleVideo);
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = true;
        this.profil = false;
        this.aturan = false;
        this.faq = false;
      },
    },
    showProfil: {
      get() {
        return this.visibleProfil;
      },
      set(visibleProfil) {
        this.$emit("profilClicked", visibleProfil);
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = false;
        this.profil = true;
        this.aturan = false;
        this.faq = false;
        // console.log('beranda ' + this.beranda);
        // console.log('artikel ' + this.artikel);
        // console.log('foto ' + this.foto);
        // console.log('video ' + this.video);
        // console.log('profil ' + this.profil);
      },
    },
    showAturan: {
      get() {
        return this.visibleAturan;
      },
      set(visibleAturan) {
        this.$emit("aturanClicked", visibleAturan);
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = false;
        this.profil = false;
        this.aturan = true;
        this.faq = false;
      },
    },
    showFaq: {
      get() {
        return this.visibleFaq;
      },
      set(visibleFaq) {
        this.$emit("faqClicked", visibleFaq);
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = false;
        this.profil = false;
        this.aturan = false;
        this.faq = true;
        // this.$emit("visibleBeranda", false);
        // this.$emit("visibleArtikel", false);
        // this.$emit("visibleFoto", false);
        // this.$emit("visibleVideo", false);
        // this.$emit("visibleProfil", false);
        // this.$emit("visibleAturan", false);
        // this.$emit("visibleFaq", true);
      },
    },
  },
  methods: {
    sendEmit(x, param) {
      this.$emit("emit", x);
      if (param == "foto") {
        this.beranda = false;
        this.artikel = false;
        this.foto = true;
        this.video = false;
        this.profil = false;
        this.aturan = false;
        this.faq = false;
      }
      if (param == "video") {
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = true;
        this.profil = false;
        this.aturan = false;
        this.faq = false;
      }
      if (param == "profil") {
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = false;
        this.profil = true;
        this.aturan = false;
        this.faq = false;
      }
      if (param == "aturan") {
        this.beranda = false;
        this.artikel = false;
        this.foto = false;
        this.video = false;
        this.profil = false;
        this.aturan = true;
        this.faq = false;
      }
    },
  },
};
</script>
